import React, { useState } from "react";
import { Button } from "antd";

import AIProcessingButtonFrame from "@/components/ui/AIProcessingButtonFrame";

interface RenderButtonProps {
  onClick: () => void;
  disabled: boolean;
  className: string;
  isProcessing: boolean;
}

interface ProcessingButtonProps {
  onClick: () => Promise<void> | void;
  isProcessing?: boolean;
  processingText?: string;
  className?: string;
  frameClassName?: string;
  renderButton?: (props: RenderButtonProps) => React.ReactNode;
  width?: string;
  height?: string;
}

function ProcessingButton({
  onClick,
  isProcessing: isProcessingProp,
  processingText = "Processing...",
  className = "",
  frameClassName = "",
  renderButton,
  width,
  height,
}: ProcessingButtonProps) {
  const [isProcessingInternal, setIsProcessingInternal] = useState(false);
  const isControlled = isProcessingProp !== undefined;
  const isProcessing = isControlled ? isProcessingProp : isProcessingInternal;
  const buttonClassName = `ai-processing-button${isProcessing ? " ai-processing-button--active" : ""}${
    className ? ` ${className}` : ""
  }`;

  const handleClick = async () => {
    if (isProcessing) return;

    if (!isControlled) {
      setIsProcessingInternal(true);
    }

    try {
      await onClick();
    } finally {
      if (!isControlled) {
        setIsProcessingInternal(false);
      }
    }
  };

  const renderedButton = renderButton ? (
    renderButton({
      onClick: handleClick,
      disabled: isProcessing,
      className: buttonClassName,
      isProcessing,
    })
  ) : (
    <Button className={buttonClassName} onClick={handleClick} disabled={isProcessing}>
      <span className={isProcessing ? "ai-processing-label" : undefined}>
        {isProcessing ? processingText : "Continue"}
      </span>
    </Button>
  );

  return (
    <AIProcessingButtonFrame active={isProcessing} className={frameClassName} width={width} height={height}>
      {renderedButton}
    </AIProcessingButtonFrame>
  );
}

export default ProcessingButton;
